import { IProsecutorOffice } from 'APIPackage/KnmModule/interfaces/IProsecutorOffice';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';

export const convertAgreementsProsecutorOrganizationToFormValues = (
  prosecutorOrganization: IProsecutorOffice | null,
): IUserOrganisationSelectOption | undefined => {
  return !prosecutorOrganization
    ? undefined
    : {
        ...prosecutorOrganization,
        id: prosecutorOrganization.id || '',
        ervkUuid: prosecutorOrganization.ervkUuid || undefined,
        ervkVersionUuid: prosecutorOrganization.ervkVersionUuid || undefined,
        code: prosecutorOrganization.code || undefined,
        label: prosecutorOrganization.name || '',
        value: prosecutorOrganization.id || '',
        fullName: prosecutorOrganization.name || '',
        districtName: '',
        districtId: '',
      };
};
